import * as Yup from 'yup';
import Translator from '../../core/i18n';

const T = Translator.create();

const RegExpDate = /^[0-9]{2}.[0-9]{2}.[0-9]{4}$/;
const RegExpTime = /^$|^(([01][0-9])|(2[0-3])):[0-5][0-9]$/;
const RegExpDateRange = /^[0-9]{2}.[0-9]{2}.[0-9]{4}[" "][-][" "][0-9]{2}.[0-9]{2}.[0-9]{4}$/;

export function getValidation() {
    return Yup.object().shape({
        subject: Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .max(255, T.t('r_must_be_less_characters_short'))
            .required(T.t('r_field_required_subject')),
        content: Yup.string()
            .min(1, T.t('r_one_character_required_validation'))
            .max(3500, T.t('r_error_max_char_3500'))
            .required(T.t('r_field_required')),
        dateRange: Yup.string().when('isShowDateRange', {
            is: true,
            then: Yup.string()
                .required(T.t('r_field_required'))
                .matches(RegExpDateRange, T.t('r_date_format_incorrect_validation'))
        }),
        notificationContent: Yup.string().when('isNotification', {
            is: true,
            then: Yup.string()
                .required(T.t('r_field_required'))
                .min(1, T.t('r_one_character_required_validation'))
                .max(255, T.t('r_must_be_less_characters_short'))
        }),
        targets: Yup.array().required(T.t('r_field_required_targets')) 
    });
}
